import React, { useState, useEffect } from "react"
import classNames from "classnames"

import styles from "./styles.module.scss"
import MinusIcon from "./assets/MinusIcon"
import PlusIcon from "./assets/PlusIcon"

interface Props {
	className?: string
	min: number
	max: number
	onPlus: Function
	onMinus: Function
	currentPeriod: string;
}

export default function Counter(props: Props) {
	const [value, setValue] = useState<number>(0)

	const onClickCounterBtn = (direction: string) => {
		if (direction === "minus") {
			if (value <= props.min) return

			setValue(value - 1)

			props.onMinus()
		} else {
			if (value >= props.max) return

			setValue(value + 1)

			props.onPlus()
		}
	}

	useEffect(() => {
		setValue(0)
	}, [props.currentPeriod])

	return (
		<div className={classNames(styles.counter, props.className)}>
			<button
				className={styles.counter__button}
				onClick={() => onClickCounterBtn("minus")}
				disabled={value <= props.min}
			>
				<MinusIcon />
			</button>

			<span className={styles.counter__value}>{value}</span>

			<button
				className={styles.counter__button}
				onClick={() => onClickCounterBtn("plus")}
				disabled={value >= props.max}
			>
				<PlusIcon />
			</button>
		</div>
	)
}
